import React from 'react';
import { Switch } from 'antd';

export const DisplayModeSwitch = (props) => (
  <div className="displaymode-switch-wrapper">
    <div className="displaymode-switch-title">Views</div>
    <div className="displaymode-switch">
      Tile
      <Switch {...props} />
      List
    </div>
  </div>
);
